import { useState } from "react";
import { ClipLoader } from "react-spinners";
import { useWebsiteSettings } from "../../../store/api/useWebsiteSettings";
import { useLocation } from "react-router-dom";
import { useTheme } from "../../../context/ThemeProvider";

export default function PrivacyPolicy({
  embedded = false,
}: {
  embedded?: boolean;
}) {
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);
  const path = useLocation();
  const { data } = useWebsiteSettings();
  // @ts-ignore
  const { theme } = useTheme();

  const isStandalone = path.pathname == "/privacy-policy" && !embedded;

  return (
    <div
      className={
        embedded
          ? "relative h-full min-h-0 w-full bg-primary"
          : `relative mx-auto flex min-h-[50rem] w-screen flex-col overflow-hidden bg-white ${
              isStandalone ? "h-screen pt-20" : "h-screen"
            }`
      }
    >
      {!isIframeLoaded && (
        <div className="absolute inset-0 z-10 grid place-content-center bg-primary">
          <ClipLoader
            color={theme == "dark" ? "white" : "black"}
            size={28}
          />
        </div>
      )}

      <iframe
        title="Privacy Policy"
        srcDoc={data?.data?.privacy_policy}
        className={`h-full w-full border-0 ${
          isIframeLoaded ? "opacity-100" : "opacity-0"
        }`}
        sandbox="allow-same-origin allow-scripts allow-popups"
        onLoad={() => setIsIframeLoaded(true)}
      />
    </div>
  );
}
